// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { ButtonBase, styled, Typography } from "@3778.care/goban";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const StyledButtonBase = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== "isActive",
})(({ isActive, theme: { palette, spacing } }) => ({
  height: spacing(8),
  width: spacing(20),
  textTransform: "uppercase",
  color: palette.text.secondary,
  ...(isActive && {
    color: palette.primary.main,
    borderBottom: `${spacing(0.25)} solid ${palette.primary.main}`,
  }),
}));

export const PathButton = ({ children, isActive, to, tour }) => {
  return (
    <StyledButtonBase isActive={isActive} component={Link} to={to} tour={tour}>
      <Typography variant="button" component="span">
        {children}
      </Typography>
    </StyledButtonBase>
  );
};

PathButton.propTypes = {
  isActive: PropTypes.bool,
  to: PropTypes.string.isRequired,
  tour: PropTypes.string.isRequired,
};
